const DealersFooter = () => {
  return <div className="bg-[#7BBE5A] text-[16px] text-center py-[10px] fixed w-full bottom-[50px]">© {new Date().getFullYear()} BY TAUTARA VEHICLES AND ZERONOX INC. </div>;
};
export default DealersFooter;
